<template>
  <div>
    <div id="content-course-data">
      <div class="col-12 px-5 py-3" id="course-information">
        <informations :information="information" />
      </div>

      <div class="col-12 px-5 py-3" id="course-modules">
        <module :modules="modules" :course="course" />
      </div>

      <div class="col-12 px-5 py-3" id="course-medias">
        <medias :course="course" :medias="medias" />
      </div>

      <div class="col-12 px-5 py-3" id="course-cupons">
        <cupons :course="course"/>
      </div>

      <div class="col-12 px-5 py-3" id="course-payment">
        <payment-forms :course="course" @reloadQuota="reloadQuota" />
      </div>

      <div class="col-12 px-5 py-3" id="course-quotas">
        <payment-quotas :course="course" ref="quotas" />
      </div>

      <div class="col-12 px-5 py-3" id="course-teachers">
        <teachers :course="course" ref="teachers" />
      </div>

      <div class="col-12 px-5 py-3" id="course-partners">
        <partners :course="course" ref="partners" />
      </div>

      <div class="col-12 px-5 py-3" id="course-tags">
        <tags :course="course" :tags="tags" />
      </div>
    </div>
  </div>
</template>

<script>
import Tags from './../../../components/teacher/MyCourse/Data/Tags'
import Cupons from './../../../components/teacher/MyCourse/Data/Cupons'
import Medias from './../../../components/teacher/MyCourse/Data/Medias'
import Module from './../../../components/teacher/MyCourse/Data/Module'
import PaymentForm from './../../../components/teacher/MyCourse/Data/PaymentForm'
import Quotas from './../../../components/teacher/MyCourse/Data/Quotas'
import Teachers from './../../../components/teacher/MyCourse/Data/Teachers'
import Informations from './../../../components/teacher/MyCourse/Data/Informations'
import Partners from '../../../components/teacher/MyCourse/Data/Partners.vue'
import Axios from 'axios'
import { Form, HasError } from 'vform'

export default {
  components: {
    "tags": Tags,
    "cupons": Cupons,
    "medias": Medias,
    "module": Module,
    "payment-forms": PaymentForm,
    "payment-quotas": Quotas,
    "teachers": Teachers,
    "partners": Partners,
    "informations": Informations,
  },
  data () {
    return {
      course: undefined,
      information: new Form({
        id: undefined,
        name: undefined,
        value: undefined,
        workload: undefined,
        sumary: undefined,
        description: undefined,
        requirements: undefined,
        will_learn: undefined,
        created_at: undefined,
        was_approved: undefined,
        is_sellable: undefined,
        is_actived: undefined,
        analytics_id: undefined,
        pixel_id: undefined,
        cart_link: undefined,
        is_free: undefined,
        value_sale: undefined,
        disable_doubt: false,
      }),
      payment: [],
      tags: [],
      modules: [],
      teachers: [],
      medias: {},
      partners: []
    }
  },
  methods: {
    loadCourse: function () {
      Axios.get(`/course/${ this.$route.params.id }/data`)
        .then( res => {
          let course = res.data.data

          this.course = course.id

          this.information.fill({
            id: course.id,
            name: course.name,
            value: course.value,
            workload: course.workload,
            sumary: course.sumary,
            description: course.description,
            requirements: course.requirements,
            will_learn: course.will_learn,
            created_at: course.created_at,
            was_approved: course.was_approved,
            is_sellable: course.is_sellable,
            is_actived: course.is_actived,
            analytics_id: course.analytics_id,
            pixel_id: course.pixel_id,
            cart_link: course.cart_link,
            is_free: course.is_free,
            value_sale: course.value_sale,
            disable_doubt: course.disable_doubt
          })

          this.payment = course.payment
          this.tags = course.tag
          this.modules = course.modules
          this.teachers =course.teachers
          this.partners = course.partners

          this.medias = {
            cover: course.cover,
            video: course.video,
            thumbnail: course.thumbnail
          }

        })
        .catch( err => {
          console.error( err )
        })
    },
    reloadQuota: function () {
      this.$refs.quotas.load()
    }
  },
  mounted () {
    this.loadCourse()
  }
}
</script>

<style>

</style>
